module.exports = __webpack_public_path__ + "static/media/item_16_3_comp.f6170065.png";